const CSSTransitionGroup = React.addons.CSSTransitionGroup;

class Home extends React.Component {
    render() {
        const {children,location} = this.props;
        const key = location.pathname;
		return (
            <CSSTransitionGroup
                component="div" transitionName="swap"
                transitionEnterTimeout={500} transitionLeaveTimeout={500}
                >
                {React.cloneElement(children || <div />, { key })}
            </CSSTransitionGroup>
        )
    }
}

export default Home


// WEBPACK FOOTER //
// ./project/components/Home.js